import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { LoadingSpinner } from '@/components'
import { EmployeeBalancesPerPeriod } from '@/containers'
import { PayrollPeriod } from '@/models'
import { getCurrentPayrollPeriod } from '@/redux/absences/absencesLegacyActions'
import { getPayrollPeriods } from '@/redux/app/appLegacyActions'
import { getHourBalance } from '@/redux/hourBalances/hourBalancesActions'
import { Reducers } from '@/redux/reducers'
import { useTypedDispatch as useLegacyTypedDispatch, useTypedDispatch, useTypedSelector } from '@/redux/store'
import { switchToNextOrPreviousPayrollPeriod } from '@/services/PayrollPeriodServices/PayrollPeriodService'

export const ConnectedEmployeeBalancesPerPeriod: FC = () => {
    const dispatch = useLegacyTypedDispatch()
    const typedDispatch = useTypedDispatch()

    const payrollPeriods = useSelector((state: Reducers) => state.appReducer.payrollPeriods)
    const currentPayrollPeriod = useSelector((state: Reducers) => state.absencesReducer.currentPayrollPeriod)

    const {
        isLoading,
        hourBalances,
    } = useTypedSelector((state) => state.hourBalancesReducer)

    const [activePayrollPeriod, setActivePayrollPeriod] = useState<PayrollPeriod | null>(null)

    useEffect(() => {
        if (! activePayrollPeriod) {
            dispatch(getCurrentPayrollPeriod())
            setActivePayrollPeriod(currentPayrollPeriod)
        }
    }, [currentPayrollPeriod, payrollPeriods])

    useEffect(() => {
        if (! payrollPeriods.length) {
            dispatch(getPayrollPeriods())
        }
    }, [])

    useEffect(() => {
        if (activePayrollPeriod) typedDispatch(getHourBalance(activePayrollPeriod)).then()
    }, [activePayrollPeriod])

    const switchPayrollPeriod = (nextPeriod: boolean) => {
        const payrollPeriod = activePayrollPeriod
            && switchToNextOrPreviousPayrollPeriod(activePayrollPeriod, payrollPeriods, nextPeriod)
        setActivePayrollPeriod(payrollPeriod)
    }

    if (! payrollPeriods.length || ! activePayrollPeriod) {
        return <LoadingSpinner />
    }

    return (
        <EmployeeBalancesPerPeriod
            loading={isLoading}
            activePayrollPeriod={activePayrollPeriod}
            hourBalances={hourBalances && hourBalances.length > 0 ? hourBalances[0] : undefined}
            switchPayrollPeriod={switchPayrollPeriod}
        />
    )
}
